/** DOM snapshot of the existing row; never a second implementation of its cells. */
import React, { memo } from "react";
import { Box } from "@/components/atoms/Box";

/**
 * Render the same cells using the existing drag overlay surface treatment.
 * @param props - Live row to snapshot.
 * @param props.hostRef - Attaches the inert row snapshot.
 * @returns Inert preview of the existing table row.
 */
const WatchlistOrderDndContextView = ({
  hostRef,
}: {
  readonly hostRef: (host: HTMLElement | null) => void;
}) => (
  <Box
    ref={hostRef as never}
    testID="watchlist-table-drag-preview"
    className="w-full rotate-1 overflow-hidden rounded-md border border-accent-primary bg-surface-base shadow-sm pointer-events-none"
  />
);
WatchlistOrderDndContextView.displayName = "WatchlistOrderDndContextView";
export default memo(WatchlistOrderDndContextView);
